export default __webpack_public_path__ + "static/media/PASIEKA-About-KasiaDobiecka.f75d1232.jpg";